import { MOBILE_URL_KEY, QR_KEY, SESSION_KEY } from 'contexts/SAWSContext';

const getStoreFrom = (storage: Storage) => ({
  set: (name: string, value: object | string | boolean | number) =>
    storage.setItem(name, JSON.stringify(value)),
  get: (name: string) => {
    const value = storage.getItem(name);
    try {
      return value && JSON.parse(value);
    } catch (e) {
      return value;
    }
  },
  remove: (name: string) => storage.removeItem(name),
  clear: () => {
    const rosWSConnection = storage.getItem(SESSION_KEY);
    const rosWSQR = storage.getItem(QR_KEY);
    const rosMobileURL = storage.getItem('ros_ws_mobile_url');
    storage.clear();
    if (rosWSConnection) {
      storage.setItem(SESSION_KEY, rosWSConnection);
      storage.setItem(QR_KEY, rosWSQR || '');
      storage.setItem(MOBILE_URL_KEY, rosMobileURL || '');
    }
  },
});

export const sessionStore = getStoreFrom(sessionStorage);
export const localStore = getStoreFrom(localStorage);
